"use client"
import { useFormik } from 'formik';
import React, { useState } from 'react';
import * as yup from 'yup';
import { ThankYou } from '../ThankYou';
import { COUNTRIES } from '@/lib/countries';

function ConnectPage() {
  // State to manage form data
  const validationSchema = yup.object({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    companyName: yup.string().required("Company Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    jobTitle: yup.string().required("Job Title is required"),
    country: yup.string().required("Country is required"),
    interestedIn: yup.array().of(yup.string()).required("Please select at least one"),
    message: yup.string().optional(),
  });

  const [open, setOpen] = useState(false);

  const generateTable=() => {
    return `<table>
      <tr>
        <td>First Name</td>
        <td>${formData.firstName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.lastName}</td>
      </tr>
      <tr>
        <td>Company Name</td>
        <td>${formData.companyName}</td>
      </tr>
      <tr>
        <td>Email</td>
        <td>${formData.email}</td>
      </tr>
      <tr>
        <td>Job Title</td>
        <td>${formData.jobTitle}</td>
      </tr>
      <tr>
        <td>Country</td>
        <td>${formData.country}</td>
      </tr>
      <tr>
        <td>Interested In</td>
        <td>${formData.interestedIn.join(", ")}</td>
      </tr>
      <tr>
        <td>Message</td>
        <td>${formData.message}</td>
      </tr>
      </table>`
  }

  const { values: formData, handleChange, handleSubmit, errors, resetForm, setFieldValue } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      companyName: "",
      jobTitle: "",
      country: "",
      interestedIn: [],
      message: ""
    },
    validationSchema,
    onSubmit: async () => {
      setOpen(true)
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subject: "Form filled : Connect Page", body: generateTable() }),
      });
      resetForm();
      const result = await response.json();
      if (result.success);
    }
  });

  return (
    <div className=''>
      <div className='bg-asmPageMiddleBG bg-asmPageTopBG lg:bg-top bg-bottom pb-20' style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundRepeat: "repeat", // Prevent repeating the background
        // maxWidth: 1920,
        // margin: 'auto'
      }}>
        <div className='max-w-[1920px] m-auto'>
          <div className="relative lg:flex flex-col items-center pt-8 lg:py-8 max-w-[1920px] m-auto">
            {/* Header Section */}
            <div className="font-aileron pt-20 lg:py-32 text-center font-bold">
              <div className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] lg:w-[100%] m-auto">
                Let's Chat!
              </div>
            </div>
          </div>
        </div>
        <div className="h-full -mt-10 lg:max-w-[1198px] lg:-mt-20 bg-white rounded-[40px] m-auto shadow-lg mb-20">
          <div className='flex justify-center items-center p-4 lg:p-14'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-40 lg:gap-2 w-[1920px] max-w-7xl items-center mt-10">
              <div className="text-center -mb-20 lg:mb-0 lg:-mt-20">
                <div className="w-80 h-80 md:w-[527px] md:h-[455px] flex items-center justify-center mx-auto md:mx-0 mb-4 md:-mb-10">
                  {/* Placeholder for Image */}
                  <img src={"/images/ConnectMain.svg"} alt="Connect Main" />
                </div>
                <div className='space-y-6'>
                  <div className='lg:w-[361px] lg:h-[128px] rounded-[20px] bg-[#F4F0FF] lg:ml-20 lg:flex p-4'>
                    <img src={"/images/ConnectLoc.svg"} className='w-[40px] mx-auto lg:mx-0' alt="Location Icon" />
                    <div className=''>
                      <p className="font-lato bg-custom-radial bg-clip-text text-transparent font-bold text-[24px] lg:text-start lg:ml-10">Headquarters</p>
                      <p className='font-lato text-[18px] text-[#5F6368] lg:ml-7'>2440 Louisiana Blvd NE #560, Albuquerque, NM 87110, USA</p>
                    </div>
                  </div>
                  <div className='lg:w-[361px] lg:h-[96px] rounded-[20px] bg-[#F4F0FF] lg:ml-20 lg:flex p-4'>
                    <img src={"/images/ConnectPhone.svg"} className='w-[40px] mx-auto lg:mx-0' alt="Phone Icon" />
                    <div className=''>
                      <p className='font-lato bg-custom-radial bg-clip-text text-transparent font-bold text-[24px] lg:text-start lg:ml-10'>Phone</p>
                      <p className='font-lato text-[18px] text-[#5F6368] lg:ml-10'>+1 844-391-2089</p>
                    </div>
                  </div>
                  <div className='lg:w-[361px] lg:h-[96px] rounded-[20px] bg-[#F4F0FF] lg:ml-20 lg:flex p-4'>
                    <img src={"/images/ConnectMail.svg"} className='w-[40px] mx-auto lg:mx-0' alt="Mail Icon" />
                    <div className=''>
                      <p className='font-lato bg-custom-radial bg-clip-text text-transparent font-bold text-[24px] lg:text-start lg:ml-10'>Mail</p>
                      <p className='font-lato text-[18px] text-[#5F6368] lg:ml-10'>info@securin.io</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <form className="space-y-4 w-full lg:w-[100%]" onSubmit={handleSubmit}>
                  {/* First Name and Last Name */}
                  <div className="flex flex-col lg:flex-row gap-4">
                    <div className="w-full">
                      <label htmlFor="firstName" className="block text-[#443b81] font-medium mb-2">
                        First Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                        required
                      />
                      {errors.firstName && <p className="py-2"><span className="text-red-500">{errors.firstName}</span></p>}
                    </div>
                    <div className="w-full">
                      <label htmlFor="lastName" className="block text-[#443b81] font-medium mb-2">
                        Last Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                        required
                      />
                      {errors.lastName && <p className="py-2"><span className="text-red-500">{errors.lastName}</span></p>}
                    </div>
                  </div>

                  {/* Business Email */}
                  <div>
                    <label htmlFor="email" className="block text-[#443b81] font-medium mb-2">
                      Business Email<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                      required
                    />
                    {errors.email && <p className="py-2"><span className="text-red-500">{errors.email}</span></p>}
                    
                  </div>

                  {/* Company Name and Job Title */}
                  <div className="flex flex-col lg:flex-row gap-4">
                    <div className="lg:w-[33%]">
                      <label htmlFor="companyName" className="block text-[#443b81] font-medium mb-2">
                        Company Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                        required
                      />
                      {errors.companyName && <p className="py-2"><span className="text-red-500">{errors.companyName}</span></p>}
                    </div>
                    <div className="lg:w-[33%]">
                      <label htmlFor="jobTitle" className="block text-[#443b81] font-medium mb-2">
                        Job Title<span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="jobTitle"
                        name="jobTitle"
                        value={formData.jobTitle}
                        onChange={handleChange}
                        className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                        required
                      />
                      {errors.jobTitle && <p className="py-2"><span className="text-red-500">{errors.jobTitle}</span></p>}
                    </div>
                    <div className="lg:w-[33%]">
                      <label htmlFor="country" className="block text-[#443b81] font-medium mb-2">
                        Country<span className="text-red-500">*</span>
                      </label>
                      <select
                        id="country"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-[14px] w-full focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                        required
                      >
                        <option value="">Select</option>
                        {COUNTRIES.map((country) => (
                          <option key={country.name} value={country.value}>{country.name}</option>
                        ))}
                      </select>
                      {errors.country && <p className="py-2"><span className="text-red-500">{errors.country}</span></p>}
                    </div>
                  </div>

                  {/* Interested In Section */}
                  <div>
                    <p className="font-medium text-[#443b81] mb-2">Interested in...<span className="text-red-500">*</span></p>
                    <div className="space-y-2">
                      {["Attack Surface Management", "Vulnerability Intelligence", "Vulnerability Management", "Penetration Testing", "Becoming a Partner"].map((interest) => (
                        <label key={interest} className="block">
                          <input
                            type="checkbox"
                            name="interestedIn"
                            value={interest}
                            checked={formData.interestedIn.includes(interest)}
                            onChange={handleChange}
                            className="mr-2 text-[#443b81] focus:border-1 focus:outline-none focus:border-[#5A27E7] accent-[#5A27E7]"
                          />
                          {interest}
                        </label>
                      ))}
                      {errors.interestedIn && <p className="py-2"><span className="text-red-500">{errors.interestedIn}</span></p>}
                    </div>
                  </div>

                  {/* Message Box */}
                  <div>
                    <label htmlFor="message" className="block text-[#443b81] font-medium mb-2">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="bg-[#f6f8fa] border border-gray-300 rounded-lg p-3 w-full h-24 focus:border-1 focus:outline-none focus:border-[#5A27E7]"
                    ></textarea>
                    {errors.message && <p className="py-2"><span className="text-red-500">{errors.message}</span></p>}
                  </div>

                  {/* Submit Button */}
                  <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
                    <button
                      type="submit"
                      className="bg-[#EF7B22] text-white px-6 py-3 rounded-lg w-full"
                    >
                      Submit
                    </button>
                    <span className="text-sm text-gray-500 text-center">
                      By submitting this form, you agree to our{" "}
                      <a href="/privacypolicy" className="text-blue-700 underline">
                        privacy policy
                      </a>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {open && <ThankYou onClose={setOpen}/>}
        {/* <Footer blok={blok} /> */}
      </div>
    </div>
  );
}

export default ConnectPage;